import classnames from 'classnames';
import React from 'react';

import colors from '../../designTokens/colors.module.scss';

export type Props = React.SVGAttributes<SVGElement> & {
  svg: React.FC<React.SVGAttributes<SVGElement>>;
  stroke?: keyof typeof colors | 'none';
  fill?: keyof typeof colors | 'none';
  color?: keyof typeof colors;
};

export const BaseIcon: React.FC<Props> = ({
  className,
  svg,
  stroke,
  fill = 'none',
  color,
  viewBox = '0 0 24 24',
  height = 24,
  width = 24,
  role,
  ...rest
}) => {
  return React.createElement(svg, {
    className: classnames('Icon', className),
    stroke: stroke === 'none' ? 'none' : colors[stroke],
    fill: fill === 'none' ? 'none' : colors[fill],
    color: colors[color],
    viewBox,
    height,
    width,
    role,
    ...rest,
  });
};
